import merge from 'lodash/merge';

import { Theme } from '@mui/material/styles';

import Fab from './components/fab';
import Menu from './components/menu';
import Card from './components/card';
import Link from './components/link';
import Tabs from './components/tabs';
import Chip from './components/chip';
import Lists from './components/list';
import Paper from './components/paper';
import Table from './components/table';
import Stack from './components/stack';
import Badge from './components/badge';
import Alert from './components/alert';
import Button from './components/button';
import Dialog from './components/dialog';
import Drawer from './components/drawer';
import Slider from './components/slider';
import Switch from './components/switch';
import Avatar from './components/avatar';
import AppBar from './components/appbar';
import Rating from './components/rating';
import Select from './components/select';
import Popover from './components/popover';
import Stepper from './components/stepper';
import Tooltip from './components/tooltip';
import SvgIcon from './components/svg-icon';
import Timeline from './components/timeline';
import Skeleton from './components/skeleton';
import Checkbox from './components/checkbox';
import Progress from './components/progress';
import Backdrop from './components/backdrop';
import DataGrid from './components/data-grid';
import TreeView from './components/tree-view';
import TextField from './components/textfield';
import Accordion from './components/accordion';
import Typography from './components/typography';
import Pagination from './components/pagination';
import Breadcrumbs from './components/breadcrumbs';
import RadioButton from './components/radio-button';
import ButtonGroup from './components/button-group';
import CssBaseline from './components/css-baseline';
import Autocomplete from './components/autocomplete';
import MuiDatePicker from './components/date-picker';
import ToggleButton from './components/toggle-button';
import LoadingButton from './components/loading-button';

// ----------------------------------------------------------------------

export function componentsOverrides(theme: Theme) {
  const components = merge(
    Fab(theme),
    Tabs(theme),
    Chip(theme),
    Card(theme),
    Menu(theme),
    Link(theme),
    Stack(theme),
    Badge(theme),
    Lists(theme),
    Table(theme),
    Paper(theme),
    Alert(theme),
    Switch(theme),
    Select(theme),
    Button(theme),
    Rating(theme),
    Dialog(theme),
    AppBar(theme),
    Avatar(theme),
    Slider(theme),
    Drawer(theme),
    Stepper(theme),
    Tooltip(theme),
    Popover(theme),
    SvgIcon(theme),
    Checkbox(theme),
    DataGrid(theme),
    Skeleton(theme),
    Timeline(theme),
    TreeView(theme),
    Backdrop(theme),
    Progress(theme),
    TextField(theme),
    Accordion(theme),
    Typography(theme),
    Pagination(theme),
    RadioButton(theme),
    ButtonGroup(theme),
    Breadcrumbs(theme),
    CssBaseline(theme),
    Autocomplete(theme),
    ToggleButton(theme),
    MuiDatePicker(theme),
    LoadingButton(theme)
  );

  return components;
}
